import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsightSensitivity = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.0183 24C14.2034 26.3912 16.0001 28 16.0001 28C16.0001 28 17.7967 26.3912 18.9818 24M6.51871 17C3.73516 13.9398 4.00728 9.00728 4.00728 9.00728C4.00728 9.00728 8.93976 8.73516 12 11.5187M25.4813 17C28.2648 13.9398 27.9927 9.00728 27.9927 9.00728C27.9927 9.00728 23.0602 8.73516 20 11.5187M16 21C16 21 20 17.4183 20 13C20 8.58172 16 5 16 5C16 5 12 8.58172 12 13C12 17.4183 16 21 16 21ZM16 21C16 21 12.6421 17 8.5 17C4.35786 17 1 21 1 21C1 21 4.35786 25 8.5 25C12.6421 25 16 21 16 21ZM16 21C16 21 19.3579 25 23.5 25C27.6421 25 31 21 31 21C31 21 27.6421 17 23.5 17C19.3579 17 16 21 16 21ZM11 4H11.05M21 4H21.05M16 1H16.05",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgInsightSensitivity;
